<template >
  <v-container
    fluid
    class="d-flex align-center justify-center fill-height flex-wrap"
  >
    <v-btn
      style="z-index: 4; bottom: 60px"
      rounded
      fixed
      bottom
      right
      color="primary"
      @click="openAddPointOfSaleForm"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-icon>mdi-plus</v-icon>
      <span>{{ $t(`$vuetify.company.addPointOfSaleBtn`) }}</span>
    </v-btn>
    <v-container
      fluid
      class="d-flex justify-center align-start flex-wrap ma-0 pa-0 fill-height"
    >
      <v-row>
        <v-spacer></v-spacer>
        <Search-box
          :emitDestination="searchEmitDestination"
          searchPlaceholder="Pretraži prodajna mj."
        ></Search-box>
      </v-row>
      <v-row
        class="justify-center fill-height ma-0 pa-0"
        style="position: absolute"
      >
        <v-card
          class="glass-card align-center ma-5"
          v-for="(sPoint, idx) in presentPSales"
          :key="sPoint.id"
          hover
          height="320"
          width="280"
          @click.stop="openPointOfSale(sPoint)"
          @keypress.enter.stop="openPointOfSale(sPoint)"
          :ref="`pSale${idx}`"
        >
          <!-- Glass morphism header with icon -->
          <div class="glass-header d-flex flex-column align-center justify-center">
            <div class="header-gloss"></div>
            <div class="icon-wrapper">
              <v-icon size="64" color="white">mdi-store</v-icon>
            </div>
            <div class="status-badge" :class="getStatusClass(sPoint.status)">
              {{ getStatusText(sPoint.status) }}
            </div>
          </div>

          <!-- Content section -->
          <div class="glass-content pa-4">
            <div class="content-text">
              <h3 class="location-name mb-2">{{ sPoint.name }}</h3>

              <div class="info-row d-flex align-center mb-2">
                <v-icon size="16" class="mr-2" color="primary">mdi-map-marker</v-icon>
                <span class="info-text">{{ sPoint.address }}, {{ sPoint.city }}</span>
              </div>

              <div class="info-row d-flex align-center">
                <v-icon size="16" class="mr-2" color="primary">mdi-tag</v-icon>
                <span class="info-text">{{ sPoint.location_id }}</span>
              </div>
            </div>

            <div class="arrow-indicator">
              <v-icon size="28">mdi-arrow-right-circle</v-icon>
            </div>
          </div>

          <!-- Actions footer -->
          <v-divider class="glass-divider"></v-divider>
          <v-card-actions class="glass-actions pa-3">
            <v-spacer></v-spacer>
            <v-menu offset-y nudge-left="145" v-if="!hideMenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @keypress.enter.stop=""
                  class="menu-btn"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense class="glass-menu">
                <v-list-item
                  v-for="(item, index) in locationOptions"
                  :key="index"
                  style="cursor: pointer"
                  @click="`${item.action(sPoint)}`"
                  @keypress.enter.prevent="`${item.action(sPoint)}`"
                  :disabled="sPoint.status === 'PROCESSING'"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-actions>
        </v-card>
        <div class="add-dashed-card ma-5" style="height: 320px; width: 280px;" @click="openAddPointOfSaleForm">
          <v-icon class="add-dashed-icon">mdi-plus</v-icon>
          <span class="add-dashed-text">Dodaj novo prodajno mjesto</span>
        </div>
      </v-row>
    </v-container>
    <add-point-of-sale
      ref="pointOfSaleForm"
      @success="refreshPoints"
    ></add-point-of-sale>
    <edit-point-of-sale
      ref="editPointOfSaleForm"
      @editSuccess="refreshEditPoint"
    ></edit-point-of-sale>
    <edit-spoint-receipt-settings
      ref="editPointOfSaleReceiptSettings"
      @editSuccess="refreshEditPoint"
    ></edit-spoint-receipt-settings>
    <edit-point-of-sale-taxes
      ref="editPointOfSaleTaxes"
      @editSuccess="refreshEditPoint"
    ></edit-point-of-sale-taxes>
  </v-container>
</template>
<script>

import { auth, df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import state from '@/state'
import EventBus from '@/plugins/event-bus'
import applicationSettings from '@/mixins/applicationSettings'

export default {
  props: ['company'],
  components: {
    AddPointOfSale: () => import('@/modules/company/components/AddPointOfSale'),
    EditPointOfSale: () => import('@/modules/company/components/EditPointOfSale'),
    EditSpointReceiptSettings: () => import('@/modules/company/components/EditPointOfSaleReceiptSettings'),
    EditPointOfSaleTaxes: () => import('@/modules/company/components/EditPointOfSaleTaxes')
  },
  data: vm => ({
    reveal: false,
    sellingPoint: { title: undefined, text: undefined },
    pointsOfSale: [],
    presentPSales: [],
    listeners: [],
    hideMenu: false,
    locationOptions: [
      { title: 'Postavke prodajnog mjesta', action: vm.openEditPointOfSaleForm },
      { title: 'Postavke računa', action: vm.editReceiptSettings },
      { title: 'Konfiguracija printera', action: vm.openPrinterConfiguration },
      { title: 'Konfiguracija ustrojstvenih jedinica', action: vm.openOrganizationalConfiguration }
    ],
    searchEmitDestination: 'pointOfSaleSearch'
  }),
  mixins: [applicationSettings],
  computed: {
    search () {
      return state.filter
    },
    whModule () {
      if (state.getCurrentCompany() &&
        state.getCurrentCompany().warehouse &&
        state.getCurrentCompany().warehouse === 'module') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    EventBus.$on(this.searchEmitDestination, (searchObject) => {
      this.searchAll(searchObject.searchString)
    })
    const user = state.getUser()

    if (!user.roles.ADMIN && !user.roles.SUPERADMIN) {
      this.hideMenu = true
    }
    try {
      this.$refs.pSale0[0].$el.focus()
    } catch {
      setTimeout(() => {
        if (this.$refs.pSale0 && this.$refs.pSale0[0]) {
          this.$refs.pSale0[0].$el.focus()
        }
      }, 500)
    }
    EventBus.$on('add-pSale', () => {
      if (this.$refs.pointOfSaleForm) {
        this.$refs.pointOfSaleForm.open(state.getCurrentCompany())
      }
    })

    if (this.whModule === true) {
      this.locationOptions.push({ title: 'Postavke poreza', action: this.openEditPointOfSaleTaxes }
      )
    }
  },
  created () {
    const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
    const listener = docRef.onSnapshot((doc) => {
      const data = doc.data()
      if (data?.locations && Object.keys(data.locations).length > 0) {
        this.pointsOfSale = Object.keys(data.locations)
          .map(key => data.locations[key])
          .filter(location => location?.resource_status === 'ACTIVE')
          .sort((a, b) => {
            if (a.id < b.id) return -1
            if (a.id > b.id) return 1
            return 0
          })
        this.applySearch()
      }
    })
    this.listeners.push(listener)
  },
  methods: {
    getStatusClass (status) {
      if (status === 'OK') return 'status-ok'
      if (status === 'PROCESSING') return 'status-processing'
      return 'status-default'
    },
    getStatusText (status) {
      if (status === 'OK') return 'Aktivno'
      if (status === 'PROCESSING') return 'U obradi'
      return status || 'Nepoznato'
    },
    applySearch (val) {
      const term = val !== undefined ? val : (this.search || '')
      const source = term !== ''
        ? this.pointsOfSale.filter(p => p.name.toLowerCase().includes(term.toLowerCase()))
        : this.pointsOfSale
      this.presentPSales = source.slice().sort((a, b) => a.name.localeCompare(b.name))
    },
    searchAll (val) {
      this.applySearch(val)
    },
    openEditPointOfSaleTaxes (sPoint) {
      this.$refs.editPointOfSaleTaxes.open(sPoint)
    },
    openAddPointOfSaleForm () {
      this.$refs.pointOfSaleForm.open()
    },
    openEditPointOfSaleForm (sPoint) {
      this.$refs.editPointOfSaleForm.open(sPoint)
    },
    editReceiptSettings (sPoint) {
      this.$refs.editPointOfSaleReceiptSettings.open(sPoint)
    },
    openOrganizationalConfiguration (sPoint) {
      this.$router.push({
        name: 'pointOfSale.organizationalUnitConfiguration',
        params: { companyId: state.getCurrentCompany().id, locationId: sPoint.id }
      })
    },
    openPrinterConfiguration (sPoint) {
      this.$router.push({
        name: 'pointOfSale.printerConfiguration',
        params: { companyId: state.getCurrentCompany().id, locationId: sPoint.id }
      })
    },
    openPointOfSale (sPoint) {
      if (sPoint.status !== 'OK') {
        return
      }
      state.setPointOfSale(sPoint)
      state.setAppTitle(sPoint.name)

      this.$router.push({
        name: 'pointOfSale',
        params: { companyId: state.getCurrentCompany().id, locationId: sPoint.id }
      })
    },
    refreshPoints (sPoint) {
      const itemToAdd = {
        name: sPoint.name,
        location_id: sPoint.location_id,
        cash_register_count: 0,
        user_count: 0,
        city: sPoint.city,
        address: sPoint.address,
        status: 'PROCESSING'
      }
      this.pointsOfSale.push(itemToAdd)
      this.presentPSales.push(itemToAdd)
      this.presentPSales = this.presentPSales.sort((a, b) => a.name.localeCompare(b.name))
    },
    refreshEditPoint (sPoint) {
      this.presentPSales = this.presentPSales.map(point => {
        if (point.id === sPoint.id) {
          point.name = sPoint.name
          point.address = sPoint.address
          point.city = sPoint.city
          point.location_id = sPoint.location_id
          point.status = 'PROCESSING'
        }
        return point
      })
    }
  },
  beforeDestroy () {
    EventBus.$off(this.searchEmitDestination)
    EventBus.$off('add-pSale')
    this.listeners.forEach(listener => {
      if (typeof listener === 'function') listener()
    })
    this.listeners = []
  }
}
</script>

<style scoped>
/* Glass Morphism Card */
.glass-card {
  border-radius: 24px !important;
  background: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              border-color 0.3s ease !important;
  cursor: pointer !important;
  max-width: 400px !important;
}

.glass-card::before {
  opacity: 0 !important;
}

.glass-card:hover {
  transform: translateY(-6px) scale(1.01);
  background: rgba(255, 255, 255, 0.85) !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(0, 179, 190, 0.4) !important;
}

/* Glass Header */
.glass-header {
  position: relative;
  height: 140px;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%);
  overflow: hidden;
}

.header-gloss {
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.22) 50%, transparent 100%);
  transition: left 0.5s ease;
  pointer-events: none;
  z-index: 1;
}

.glass-card:hover .header-gloss {
  left: 150%;
}

.glass-card:hover .glass-header {
  filter: brightness(1.1);
}

/* Icon Wrapper */
.icon-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.2),
    inset 0 2px 4px rgba(255, 255, 255, 0.3);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              background 0.3s ease,
              box-shadow 0.3s ease;
  will-change: transform;
}

.glass-card:hover .icon-wrapper {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.3);
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.25),
    inset 0 2px 6px rgba(255, 255, 255, 0.4);
}

.icon-wrapper .v-icon {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: filter 0.3s ease;
}

.glass-card:hover .icon-wrapper .v-icon {
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.35));
}

/* Status Badge */
.status-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.status-ok {
  background: rgba(76, 175, 80, 0.9);
  color: white;
}

.status-processing {
  background: rgba(255, 152, 0, 0.9);
  color: white;
}

.status-default {
  background: rgba(158, 158, 158, 0.9);
  color: white;
}

.glass-card:hover .status-badge {
  transform: scale(1.03);
}

/* Content Section */
.glass-content {
  background: transparent;
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-text {
  flex: 1;
  min-width: 0;
}

.arrow-indicator {
  flex-shrink: 0;
  margin-left: 10px;
  opacity: 0.6;
  transform: translateX(0);
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.arrow-indicator .v-icon {
  color: #9e9e9e !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-card:hover .arrow-indicator {
  opacity: 1;
  transform: translateX(4px);
}

.glass-card:hover .arrow-indicator .v-icon {
  color: #00bcd4 !important;
  filter: drop-shadow(0 0 8px rgba(0, 188, 212, 0.5));
}

.location-name {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
  text-shadow: 0 2px 4px rgba(255, 255, 255, 0.8);
}

.glass-card:hover .location-name {
  color: #00b3be;
}

/* Info Rows */
.info-row {
  font-size: 13px;
  color: #555;
  transition: color 0.3s ease;
}

.info-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.glass-card:hover .info-row {
  color: #333;
}

.info-row .v-icon {
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.glass-card:hover .info-row .v-icon {
  opacity: 1;
}

/* Glass Divider */
.glass-divider {
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(0, 179, 190, 0.3) 50%,
    transparent 100%);
  height: 1px;
  border: none;
}

/* Actions */
.glass-actions {
  min-height: 48px;
  background: rgba(255, 255, 255, 0.5);
}

.menu-btn {
  background: rgba(255, 255, 255, 0.6) !important;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              background 0.3s ease !important;
  will-change: transform;
}

.menu-btn:hover {
  background: rgba(0, 179, 190, 0.1) !important;
  transform: scale(1.1) rotate(90deg);
}

/* Glass Menu */
.glass-menu {
  background: rgba(255, 255, 255, 0.98) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

/* Legacy styles */
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.one-liner-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.selling-point-text {
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.selling-point-title-text {
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.add-sPoint-plus {
  height: calc(100% - 108px);
}

.add-dashed-card {
  background-color: #FAFAFA;
  border: 2px dashed #CBD5E1;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.add-dashed-card:hover {
  border-color: #00BCD4;
}

.add-dashed-card:hover .add-dashed-icon {
  color: #00BCD4 !important;
}

.add-dashed-card:hover .add-dashed-text {
  color: #00BCD4 !important;
}

.add-dashed-icon {
  font-size: 28px !important;
  color: #CBD5E1 !important;
  transition: color 0.2s ease;
}

.add-dashed-text {
  font-size: 14px;
  font-weight: 500;
  color: #94A3B8;
  transition: color 0.2s ease;
  text-align: center;
  padding: 0 16px;
}
</style>
